"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Dropdown = require("./Dropdown.styled");
var _Dropdown2 = require("./Dropdown");
var _Scrollbar = _interopRequireDefault(require("../../molecules/Scrollbar"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
var DropdownMenuText = function DropdownMenuText(_ref) {
  var values = _ref.values;
  try {
    (0, _react.useContext)(_Dropdown2.DropdownContext);
  } catch (e) {
    throw new Error('Please wrap me in the dropdown component');
  }
  var _ref2 = (0, _react.useContext)(_Dropdown2.DropdownContext),
    selectItem = _ref2.selectItem,
    size = _ref2.size,
    initialValue = _ref2.initialValue,
    setSelectedItem = _ref2.setSelectedItem,
    expanded = _ref2.expanded;
  var _ref3 = (0, _react.useState)(),
    _ref4 = _slicedToArray(_ref3, 2),
    selectedValue = _ref4[0],
    setSelectedValue = _ref4[1];
  var select = function select(e, element) {
    setSelectedValue(element.value);
    selectItem(e, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.CurrentSelection, {
      size: size,
      data: element.value,
      children: element.text
    }));
  };
  var createInitialItemText = (0, _react.useCallback)(function () {
    setSelectedValue(initialValue === null || initialValue === void 0 ? void 0 : initialValue.value);
    return initialValue ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.CurrentSelection, {
      size: size,
      data: initialValue.value,
      children: initialValue.text
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.CurrentSelection, {
      size: size,
      children: "Make a selection..."
    });
  }, [initialValue, size]);
  var isSelected = function isSelected(value) {
    return selectedValue === value;
  };
  (0, _react.useEffect)(function () {
    return setSelectedItem(createInitialItemText());
  }, [createInitialItemText, setSelectedItem]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.Menu, {
    expanded: expanded,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Scrollbar.default, {
      children: values.map(function (element) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Dropdown.Option, {
          size: size,
          onClick: function onClick(e) {
            return select(e, element);
          },
          selected: isSelected(element.value),
          children: [element.text, isSelected(element.value) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            size: size,
            icon: 'tick'
          })]
        }, element.value);
      })
    })
  });
};
DropdownMenuText.defaultProps = {
  values: []
};
var _default = exports.default = DropdownMenuText;